export const isTableRowFirst = (document, node) =>
  node.key === document.getParent(node.key).nodes.get(0).key;
